module.exports = __webpack_public_path__ + "img/25.3e1023df.png";